import styled, { css, keyframes } from 'styled-components';
import { getSizeStyles, SizeTypes } from '../sizes';

const setVariantStyles = (
  isDisabled: boolean | undefined,
  variant: 'primary' | 'secondary' | 'tertiary' | 'white'
) => {
  if (
    (isDisabled && variant === 'primary') ||
    (isDisabled && variant === 'white')
  ) {
    return css`
      background: rgba(0, 0, 0, 0.05);
      color: rgba(103, 103, 103, 1);
      cursor: default;
    `;
  }
  if (isDisabled && variant === 'secondary') {
    return css`
      background: rgba(0, 0, 0, 0.09);
      color: rgba(103, 103, 103, 1);
      border: 1px solid rgba(0, 0, 0, 0.085);
      cursor: default;
    `;
  }
  if (isDisabled && variant === 'tertiary') {
    return css`
      background: rgba(0, 0, 0, 0.05);
      color: rgba(103, 103, 103, 1);
      border: 1px solid rgba(0, 0, 0, 0.085);
      cursor: default;
    `;
  }

  if (variant === 'primary') {
    return css`
      background: ${({ theme }) => theme.palette.primary};
      color: white;
      &:hover {
        background: ${({ theme }) => theme.palette.primaryHover};
      }
    `;
  }
  if (variant === 'secondary') {
    return css`
      background: white;
      color: black;
      border: 1px solid rgba(0, 0, 0, 0.23);
      &:hover {
        border: 1px solid rgba(0, 0, 0, 0.34);
      }
    `;
  }
  if (variant === 'tertiary') {
    return css`
      background: transparent;
      color: black;
      border: 1px solid rgba(0, 0, 0, 0.23);
      &:hover {
        border: 1px solid rgba(0, 0, 0, 0.34);
      }
    `;
  }
  if (variant === 'white') {
    return css`
      background: white;
      color: ${({ theme }) => theme.palette.primary};

      &:hover {
        background: rgb(243, 243, 243);
      }
    `;
  }
};

const getButtonWidth = (width: string | undefined, fullWidth?: boolean) => {
  if (fullWidth) {
    return '100%';
  } else if (width) {
    return width;
  } else {
    return 'auto';
  }
};

export const Button = styled.button<{
  variant: 'primary' | 'secondary' | 'tertiary' | 'white';
  fullWidth?: boolean;
  width?: string;
  customDisabled?: boolean;
  loading?: string;
  size: SizeTypes;
}>`
  box-sizing: border-box;
  border: none;
  ${({ size }) => getSizeStyles(size)};
  border-radius: 4px;
  width: ${({ width, fullWidth }) => getButtonWidth(width, fullWidth)};
  cursor: pointer;
  ${({ customDisabled, variant }) => setVariantStyles(customDisabled, variant)};
  font-size: 0.9rem;
`;
export const ButtonBody = styled.div<{ isLoading?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  color: ${({ isLoading }) =>
    isLoading ? 'rgba(103, 103, 103, 1)' : 'inherit'};
  position: relative;
`;

const loadingSpinner = keyframes`
  from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
`;

export const ButtonLoading = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  border: 3px solid rgba(0, 0, 0, 0.23);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: ${loadingSpinner} 1s ease infinite;
  margin-right: 3px;
`;

export const ButtonTitle = styled.div`
  visibility: hidden;
`;
